import { Link } from "react-router-dom";
import { Instagram, Music2, Play } from "lucide-react";

export function ReelGrid({ embeds, categories }) {
  // If we have real embeds, render them; otherwise show category placeholders.
  if (embeds && embeds.length > 0) {
    return (
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {embeds.map((e) => (
          <EmbedCard key={e.id} embed={e} />
        ))}
      </div>
    );
  }
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {categories.map((cat, i) => (
        <a
          key={cat}
          href="https://instagram.com/leleskye_"
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`reel-placeholder-${i}`}
          className="group relative aspect-[4/5] overflow-hidden rounded-[1.5rem] border border-champagne/30 bg-gradient-to-br from-blush/30 via-ivory to-champagne/20 flex flex-col items-center justify-center text-center p-6 transition-all hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(232,183,196,0.3)]"
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-ivory/80 text-bronze shadow-sm group-hover:bg-bronze group-hover:text-ivory transition-colors">
            <Play size={22} className="ml-0.5" />
          </span>
          <p className="mt-5 font-heading text-xl text-ink">{cat}</p>
          <p className="mt-2 label-eyebrow">View on Instagram</p>
        </a>
      ))}
    </div>
  );
}

export function EmbedCard({ embed }) {
  const isTikTok = embed.platform === "tiktok";
  return (
    <a
      href={embed.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`embed-card-${embed.id}`}
      className="group relative aspect-[4/5] overflow-hidden rounded-[1.5rem] border border-champagne/30 bg-ink/5"
    >
      {embed.thumbnail_url ? (
        <img src={embed.thumbnail_url} alt={embed.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-blush/40 via-ivory to-champagne/30" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />
      <div className="absolute top-4 right-4 flex h-9 w-9 items-center justify-center rounded-full bg-ivory/90 text-bronze">
        {isTikTok ? <Music2 size={16} /> : <Instagram size={16} />}
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-5">
        {embed.category && <p className="font-body text-[0.65rem] uppercase tracking-[0.2em] text-blush">{embed.category}</p>}
        <p className="mt-1 font-heading text-lg text-ivory leading-snug line-clamp-2">{embed.title || "Watch the reel"}</p>
      </div>
    </a>
  );
}
